import * as Scrivito from "scrivito";
import classNames from "classnames";
import { useMobileNavigation } from "^/Context/MobileNavigationContext";
import { isLiv } from "^/utils/isLiv";

function MobileNavBar() {
  const { showSearch, showNavigation, dispatch } = useMobileNavigation();

  const OpenNavigationButton = ({ className }) => (
    <button
      onClick={() =>
        dispatch({
          type: "toggleNavigation",
          payload: { field: "showNavigation", value: !showNavigation },
        })
      }
      title="Navigation"
      className={`btn btn-link ${className}`}
    >
      <i
        className={classNames("las is-150", {
          "la-bars": !showNavigation,
          "la-times": showNavigation,
        })}
      />
    </button>
  );

  if (isLiv()) {
    return (
      <div className="row m-0">
        <div className="col-12 text-center">
          <OpenNavigationButton className="mx-auto" />
        </div>
      </div>
    );
  }

  return (
    <div className="row m-0">
      <div className="col-3 text-center pt-2 border-top">
        <button
          onClick={() =>
            dispatch({
              type: "toggleNavigation",
              payload: { field: "showSearch", value: !showSearch },
            })
          }
          className="btn btn-link"
          title="search"
        >
          <i title="search" className="las la-search is-150" />
        </button>
      </div>
      <div className="col-6 border-left border-top border-right text-center pt-2" />
      <div className="col-3 text-center pt-2 border-top">
        <OpenNavigationButton />
      </div>
    </div>
  );
}
export default Scrivito.connect(MobileNavBar);
